import {DateWithTimeIntervals} from 'screens/InsomniaSurvey/components/TimeSelector/TimeSelector';
import {Schedule} from 'externalAPIs/insurance-eligibility';

export const scheduleToDateWithTimeIntervals = (schedule: Schedule): DateWithTimeIntervals[] => {
  const intervals: DateWithTimeIntervals[] = [];
  for (const day in schedule.slots) {
    const timeIntervals = schedule.slots[day].map((slot: any) => {
      const slotTime = new Date(slot.time);
      return {
        startTime: slotTime,
        endTime: new Date(slotTime.getTime() + 60 * 60000), // 60 minutes later
        providerId: slot.providerId,
      };
    });

    // ensures that we get the correct day in the user's timezone
    const [y, m, d] = day.split('-').map(Number);
    const date = new Date(y, m - 1, d);

    intervals.push({date, timeIntervals});
  }
  return intervals;
};
